import styled from 'styled-components';
import { theme } from '../../../theme/GlobalTheme';

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.md};
  width: 100%;
`;

export const LabelWrapper = styled.label`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.textDark};
  margin-bottom: ${theme.spacing.sm};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${theme.typography.fontWeight.bold};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-family: ${theme.typography.fontFamily};
`;

export const ValueInput = styled.input`
  width: 80px;
  margin-left: ${theme.spacing.sm};
  border: 2px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.body};
  background-color: ${theme.colors.white};
  color: ${theme.colors.text};
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.secondary};
    box-shadow: 0px 0px 0px 3px rgba(194, 42, 144, 0.1);
  }
`;

export const Slider = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 20px;
  background-color: ${theme.colors.tertiary};
  outline: none;
  border-radius: 25px;
  margin: ${theme.spacing.sm} 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0 8px rgba(0, 33, 105, 0.3);
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: ${theme.colors.white};
    cursor: ew-resize;
    border-radius: 50%;
    border: 3px solid ${theme.colors.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: box-shadow 0.2s ease-in-out;
  }

  &:active::-webkit-slider-thumb {
    border-color: ${theme.colors.secondary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: ${theme.colors.white};
    cursor: ew-resize;
    border-radius: 50%;
    border: 3px solid ${theme.colors.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: ${theme.typography.fontSize.small};
  color: ${theme.colors.text};
  margin-top: ${theme.spacing.xs};
`;

export const MinValue = styled.span`
  width: 40px;
  text-align: left;
  font-weight: ${theme.typography.fontWeight.bold};
`;

export const MaxValue = styled.span`
  width: 40px;
  text-align: right;
  font-weight: ${theme.typography.fontWeight.bold};
`;
